import { divisionTypes } from "./division-types";
import { roleTypes } from "./role-types";

export const sizeStatus = {
  SIZE_REQUIRED: "SIZE_REQUIRED",
  SIZE_NOT_REQUIRED: "SIZE_NOT_REQUIRED",
  SIZE_OPTIONAL: "SIZE_OPTIONAL",
};

export const allDivisions = [
  divisionTypes.PAINT,
  divisionTypes.CLEAN,
  divisionTypes.SHAMPOO,
  divisionTypes.HALLWAY_CLEAN,
];
export const employeeDivisions = [
  divisionTypes.PAINT,
  divisionTypes.HALLWAY_CLEAN,
];
export const subcontractorDivisions = [
  divisionTypes.CLEAN,
  divisionTypes.PAINT,
  divisionTypes.HALLWAY_CLEAN
]
export const officeDivisions = ["None"];
export const leadDivisions = [
  divisionTypes.PAINT,
  divisionTypes.CLEAN,
  divisionTypes.SHAMPOO,
];

export const leadTiers = ["0", "1", "2", "3", "4"];
export const roles = [
  roleTypes.EMPLOYEE,
  roleTypes.FRONT_DESK,
  roleTypes.LEAD,
  roleTypes.SCHEDULING_MANAGER,
  roleTypes.INVOICING_MANAGER,
  roleTypes.ADMIN,
  roleTypes.QC_MANAGER,
  roleTypes.SUBCONTRACTOR,
  roleTypes.UPPER_LEVEL_MANAGEMENT
];
export const shirtSizes = ["Small", "Medium", "Large", "XL", "2XL", "3XL"];

export const billingTerms = ["Net 30", "Due on receipt"];

export const phoneCarriers = [
  "Sprint",
  "T-Mobile",
  "Verizon",
  "Verizon2",
  "Virgin Mobile",
  "AT&T",
  "Boost",
  "Nextel",
  "Straight Talk",
  "Tracfone",
  "Cricket",
  "MetroPCS",
  "MetroPCS2",
  "Bellsouth",
];

export const accentWallActions = ["Added", "Removed", "Repainted"];

export const accentWallRoomTypes = [
  "Master Bedroom",
  "Guest Bedroom",
  "Other Bedroom",
  "Living Room",
  "Hallway",
  "Dining Room",
  "Kitchen",
  "Master Bathroom",
  "Guest Bathroom",
];

export const accentWallNumberOfWalls = [1, 2, 3, 4];

export const SMSGateways = {
  Sprint: "messaging.sprintpcs.com",
  "T-Mobile": "tmomail.net",
  Verizon: "vtext.com",
  Verizon2: "vzwpix.com",
  "Virgin Mobile": "vmobl.com",
  "AT&T": "txt.att.net",
  Boost: "myboostmobile.com",
  Nextel: "messaging.nextel.com",
  "Straight Talk": "VTEXT.COM",
  Tracfone: "mmst5.tracfone.com",
  Cricket: "mms.cricketwireless.net",
  MetroPCS: "mms.metropcs.net",
  MetroPCS2: "mymetropcs.com",
  Bellsouth: "wireless.bellsouth.com",
};

export const paintVendors = [
  "Hirshfields/ICI",
  "Sherwin",
  "Abbot",
  "Home Depot",
  "Hamernick",
  "Schramm Wallpaper",
  "Lowes",
];

export const whoPaysForPaint = [
  "Client Pays/Client Orders",
  "AKP Pays/AKP Orders",
  "Client Pays/AKP Orders",
];

export const paintSuppliers = [
  "Abbot",
  "Hamernick",
  "Hirshfields/ICI",
  "Home Depot",
  "Lowes",
  "Schramm Wallpapering",
  "Sherwin",
];

export const stateNames = [
  "Alabama",
  "Alaska",
  "Arizona",
  "Arkansas",
  "California",
  "Colorado",
  "Connecticut",
  "Delaware",
  "Florida",
  "Georgia",
  "Guam",
  "Hawaii",
  "Idaho",
  "Illinois",
  "Indiana",
  "Iowa",
  "Kansas",
  "Kentucky",
  "Louisiana",
  "Maine",
  "Maryland",
  "Massachusetts",
  "Michigan",
  "Minnesota",
  "Mississippi",
  "Missouri",
  "Montana",
  "Nebraska",
  "Nevada",
  "New Hampshire",
  "New Jersey",
  "New Mexico",
  "New York",
  "North Carolina",
  "North Dakota",
  "Ohio",
  "Oklahoma",
  "Oregon",
  "Pennsylvania",
  "Rhode Island",
  "South Carolina",
  "South Dakota",
  "Tennessee",
  "Texas",
  "Utah",
  "Vermont",
  "Virginia",
  "Washington",
  "West Virginia",
  "Wisconsin",
  "Wyoming",
];

export const startTimes = [
  { value: "6:00 AM", label: "6:00 AM", shouldBeDisplayed: true },
  { value: "6:15 AM", label: "6:15 AM", shouldBeDisplayed: true },
  { value: "6:30 AM", label: "6:30 AM", shouldBeDisplayed: true },
  { value: "6:45 AM", label: "6:45 AM", shouldBeDisplayed: true },
  { value: "7:00 AM", label: "7:00 AM", shouldBeDisplayed: true },
  { value: "7:15 AM", label: "7:15 AM", shouldBeDisplayed: true },
  { value: "7:30 AM", label: "7:30 AM", shouldBeDisplayed: true },
  { value: "7:45 AM", label: "7:45 AM", shouldBeDisplayed: true },
  { value: "8:00 AM", label: "8:00 AM", shouldBeDisplayed: true },
  { value: "8:15 AM", label: "8:15 AM", shouldBeDisplayed: true },
  { value: "8:30 AM", label: "8:30 AM", shouldBeDisplayed: true },
  { value: "8:45 AM", label: "8:45 AM", shouldBeDisplayed: true },
  { value: "9:00 AM", label: "9:00 AM", shouldBeDisplayed: true },
  { value: "9:15 AM", label: "9:15 AM", shouldBeDisplayed: true },
  { value: "9:30 AM", label: "9:30 AM", shouldBeDisplayed: true },
  { value: "9:45 AM", label: "9:45 AM", shouldBeDisplayed: true },
  { value: "10:00 AM", label: "10:00 AM", shouldBeDisplayed: true },
  { value: "10:15 AM", label: "10:15 AM", shouldBeDisplayed: true },
  { value: "10:30 AM", label: "10:30 AM", shouldBeDisplayed: true },
  { value: "10:45 AM", label: "10:45 AM", shouldBeDisplayed: true },
  { value: "11:00 AM", label: "11:00 AM", shouldBeDisplayed: true },
  { value: "11:15 AM", label: "11:15 AM", shouldBeDisplayed: true },
  { value: "11:30 AM", label: "11:30 AM", shouldBeDisplayed: true },
  { value: "11:45 AM", label: "11:45 AM", shouldBeDisplayed: true },
  { value: "12:00 PM", label: "12:00 PM", shouldBeDisplayed: true },
  { value: "12:15 PM", label: "12:15 PM", shouldBeDisplayed: true },
  { value: "12:30 PM", label: "12:30 PM", shouldBeDisplayed: true },
  { value: "12:45 PM", label: "12:45 PM", shouldBeDisplayed: true },
  { value: "1:00 PM", label: "1:00 PM", shouldBeDisplayed: true },
  { value: "1:15 PM", label: "1:15 PM", shouldBeDisplayed: true },
  { value: "1:30 PM", label: "1:30 PM", shouldBeDisplayed: true },
  { value: "1:45 PM", label: "1:45 PM", shouldBeDisplayed: true },
  { value: "2:00 PM", label: "2:00 PM", shouldBeDisplayed: true },
  { value: "2:15 PM", label: "2:15 PM", shouldBeDisplayed: true },
  { value: "2:30 PM", label: "2:30 PM", shouldBeDisplayed: true },
  { value: "2:45 PM", label: "2:45 PM", shouldBeDisplayed: true },
  { value: "3:00 PM", label: "3:00 PM", shouldBeDisplayed: true },
  { value: "3:15 PM", label: "3:15 PM", shouldBeDisplayed: true },
  { value: "3:30 PM", label: "3:30 PM", shouldBeDisplayed: true },
  { value: "3:45 PM", label: "3:45 PM", shouldBeDisplayed: true },
  { value: "4:00 PM", label: "4:00 PM", shouldBeDisplayed: true },
  { value: "4:15 PM", label: "4:15 PM", shouldBeDisplayed: true },
  { value: "4:30 PM", label: "4:30 PM", shouldBeDisplayed: true },
  { value: "4:45 PM", label: "4:45 PM", shouldBeDisplayed: true },
  { value: "5:00 PM", label: "5:00 PM", shouldBeDisplayed: true },
];

export const sizes = [
  "1 Bedroom, 1 Bath",
  "1 Bedroom + Den",
  "2 Bedroom, 1 Bath",
  "2 Bedroom + Den",
  "2 Bedroom, 2 Bath",
  "2 Bedroom, 3 Bath",
  "3 Bedroom, 1 Bath",
  "3 Bedroom, 2 Bath",
  "3 Bedroom, 3 Bath",
  "3 Bedroom + Den, 2 Bath",
  "3 Bedroom, 3 Bath",
  "4 Bedroom, 2 Bath",
  "4 Bedroom, 4 Bath",
  "5 Bedroom",
  "6 Bedroom",
  "Studio",
  "Penthouse",
  "2 Bedroom Penthouse",
  "3 Bedroom Penthouse",
  "1 Bedroom Loft",
  "2 Bedroom Loft",
  "3 Bedroom Loft",
  "1 Bedroom Flat",
  "2 Bedroom Flat",
  "3 Bedroom Flat",
  "1 Bedroom Townhome",
  "2 Bedroom Townhome",
  "3 Bedroom Townhome",
  "4 Bedroom Townhome",
];

export const orderedJobStatus = {
  ACCEPTED: "Accepted",
  SCHEDULED: "Scheduled",
  COMPLETED: "Completed",
  CANCELLED: "Cancelled",
  INCOMPLETE: "Incomplete",
  INCOMPLETE_WITH_HOURS: "Incomplete With Hours",
};

export const orderedJobStatuses = [
  "Accepted",
  "Scheduled",
  "Completed",
  "Cancelled",
  "Incomplete",
  "Incomplete With Hours",
];

export const customerOrderedJobStatus = {
    ACCEPTED: "Accepted",
    SCHEDULED: "Scheduled",
    COMPLETED: "Completed",
    CANCELLED: "Cancelled",
    INCOMPLETE: "Incomplete",
};

export const customerOrderedJobStatuses = [
    "Accepted",
    "Scheduled",
    "Completed",
    "Cancelled",
    "Incomplete",
];

export const orderedJobDivisions = ["Paint", "Clean", "Shampoo"];

export const orderedJobDivision = {
  PAINT: "Paint",
  CLEAN: "Clean",
  SHAMPOO: "Shampoo",
};

export const taskTypes = {
  UPGRADE: "Upgrade",
  FIFTY_PERCENT: "50 Percent",
  WORK_ORDER: "Work Order",
  HALLWAY: "Hallway",
  EXTERIOR: "Exterior",
  PARTIAL: "Partial",
  TOUCH_UP: "Touch Up",
  FIX_UP: "Fix Up",
  MAINTAIN_IT: "Maintain It"
};

export const upgradeTaskStatuses = ["Yes", "No", "N/A"];

export const paintTypes = [
  "Turn",
  "Upgrade",
  "Work Order",
  "Hallway",
  "Touch Up",
  "Exterior",
  "Partial",
  "Color Change",
  "Product Change",
  "50 Percent",
  taskTypes.MAINTAIN_IT
];

export const cleanTypes = ["Turn", "Hallway", "Touch Up", "Partial", "Work Order", taskTypes.MAINTAIN_IT];

export const customerPaintTypes = [
  "Turn",
  "Work Order",
  "Color Change",
  "Product Change",
];

export const customerCleanTypes = ["Turn", "Work Order"];

export const preferredArrivals = ["Normal", "First A.M."];

export const preferredArrivalOptions = {
  NORMAL: "Normal",
  FIRST_AM: "First A.M.",
};

export const majorHolidays = [
  "New Year's Day",
  "Thanksgiving Day",
  "Christmas Day",
  "Christmas Day (substitute day)",
  "Labor Day",
  "Independence Day",
  "Independence Day (substitute day)",
];

export const columnSortSelections = [
    { value: "lead", label: "Lead" },
    { value: "division", label: "Division" },
    { value: "complexName", label: "Complex" },
    { value: "complexCity", label: "City" },
    { value: "priority", label: "Priority" },
    { value: "taskType", label: "Type" },
    { value: "apartmentNumber", label: "Apartment" },
    { value: "apartmentSize", label: "Size" },
    { value: "initialDetails", label: "Details" },
    { value: "poNumber", label: "PO Number" },
    { value: "preferredArrival", label: "Preferred Arrival" },
    { value: "workDate", label: "Work Date" },
    { value: "status", label: "Status" },
    { value: "comments", label: "Comments" },
    { value: "administrativeComment", label: "Admin Comments" },
    { value: "placedOnline", label: "Placed Online" },
    { value: "lastUpdatedUser", label: "Last Updated By" },
    { value: "lastUpdatedDate", label: "Last Updated Date" },
];

/*
 * Daily Sheet Constants
 */

export const timeSelections = [
  { value: 0.0, label: "0:00" },
  { value: 0.25, label: "0:15" },
  { value: 0.5, label: "0:30" },
  { value: 0.75, label: "0:45" },
  { value: 1.0, label: "1:00" },
  { value: 1.25, label: "1:15" },
  { value: 1.5, label: "1:30" },
  { value: 1.75, label: "1:45" },
  { value: 2.0, label: "2:00" },
  { value: 2.25, label: "2:15" },
  { value: 2.5, label: "2:30" },
  { value: 2.75, label: "2:45" },
  { value: 3.0, label: "3:00" },
  { value: 3.25, label: "3:15" },
  { value: 3.5, label: "3:30" },
  { value: 3.75, label: "3:45" },
  { value: 4.0, label: "4:00" },
  { value: 4.25, label: "4:15" },
  { value: 4.5, label: "4:30" },
  { value: 4.75, label: "4:45" },
  { value: 5.0, label: "5:00" },
  { value: 5.25, label: "5:15" },
  { value: 5.5, label: "5:30" },
  { value: 5.75, label: "5:45" },
  { value: 6.0, label: "6:00" },
  { value: 6.25, label: "6:15" },
  { value: 6.5, label: "6:30" },
  { value: 6.75, label: "6:45" },
  { value: 7.0, label: "7:00" },
  { value: 7.25, label: "7:15" },
  { value: 7.5, label: "7:30" },
  { value: 7.75, label: "7:45" },
  { value: 8.0, label: "8:00" },
  { value: 8.25, label: "8:15" },
  { value: 8.5, label: "8:30" },
  { value: 8.75, label: "8:45" },
  { value: 9.0, label: "9:00" },
  { value: 9.25, label: "9:15" },
  { value: 9.5, label: "9:30" },
  { value: 9.75, label: "9:45" },
  { value: 10.0, label: "10:00" },
];

export const trimAndDoorOptions = [
  "No",
  "Full - Trim Only",
  "Full - Doors Only",
  "Full - Both",
  "Touch-Up - Trim Only",
  "Touch-Up - Doors Only",
  "Touch-Up - Both",
];

export const invoiceStatusOptions = {
  AUTO_INVOICE: "Auto Invoice",
  MANUAL_INVOICE: "Manual Invoice",
};

export const supplyDateRange = 90;
